import * as React from 'react';
import { EntrataPropertyConfiguration } from '../../../../../api/PropertyIntegration';
import CollapsibleCard from '../../../../common/CollapsibleCard';
import CheckboxLabeled from '../../../../common/form/CheckboxLabeled';
import FormInput from '../../../../common/form/Input';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../../utilities/identity';

interface Props {
    config?: EntrataPropertyConfiguration;
    update: (newConfig?: EntrataPropertyConfiguration) => void;
}

const EntrataConfigurationSection = (props: Props) => {
    
const isUser =
userIsCompanyManageUser() ||
userIsPropertyManageUser() ||
userIsSystemManageUser();
return(
    <CollapsibleCard
        cardTitle="Entrata Configuration"
        cardOpen={!!props.config}
        onCardOpenChange={open =>{
            if (isUser)  return;
            props.update(
                open
                    ? {
                          username: '',
                          password: '',
                          propertyId: '',
                          subdomain: '',
                          useForAvailability: false,
                          suppressTourForwarding: false,
                          editInProgress: true,
                          enableSelfGuided: false
                      }
                    : undefined
            )
        }}
    >
        {props.config && (
            <div>
                {props.config.subdomain && !props.config.editInProgress ? (
                    <div>
                        <p>
                            <b>Connected to {props.config.subdomain}</b>
                        </p>
                        {props.config.username && <p>User: {props.config.username}</p>}
                        {props.config.propertyId && <p>Property: {props.config.propertyId}</p>}
                    </div>
                ) : (
                    <div>
                        <p>Entrata Core configuration accessed through Entrata App Store.</p>
                        <p>
                            <b>
                                Please use this configuration only if you do not have Entrata Core.
                            </b>
                        </p>
                        <FormInput
                            labelProps={{
                                labelText: 'Username',
                                invalidText: 'Please enter the username for an Entrata user'
                            }}
                            inputProps={{
                                id: 'entrata-username',
                                name: 'username',
                                value: props.config.username,
                                type: 'string',
                                required: true,
                                disabled: isUser  
                            }}
                            onChange={(_name, value) =>
                                !isUser && props.update({ ...props.config!, username: value.toString() })
                            }
                        />
                        <FormInput
                            labelProps={{
                                labelText: 'Password',
                                invalidText:
                                    'Please enter the password for the Entrata user specified above'
                            }}
                            inputProps={{
                                id: 'entrata-password',
                                name: 'password',
                                value: props.config.password,
                                type: 'string',
                                required: true,
                                disabled: isUser  
                            }}
                            onChange={(_name, value) =>
                                !isUser && props.update({ ...props.config!, password: value.toString() })
                            }
                        />
                        <FormInput
                            labelProps={{
                                labelText: 'Property ID',
                                invalidText:
                                    'Please enter the Entrata Property ID for this property'
                            }}
                            inputProps={{
                                id: 'entrata-property-id',
                                name: 'propertyId',
                                value: props.config.propertyId,
                                type: 'string',
                                required: true,
                                disabled: isUser  
                            }}
                            onChange={(_name, value) =>
                                !isUser && props.update({ ...props.config!, propertyId: value.toString() })
                            }
                        />
                        <FormInput
                            labelProps={{
                                labelText: 'Subdomain',
                                invalidText: 'Please enter the Entrata subdomain'
                            }}
                            inputProps={{
                                id: 'entrata-subdomain',
                                name: 'subdomain',
                                value: props.config.subdomain,
                                type: 'string',
                                required: true,
                                disabled: isUser  
                            }}
                            onChange={(_name, value) =>
                                !isUser && props.update({ ...props.config!, subdomain: value.toString() })
                            }
                        />
                    </div>
                )}
                <CheckboxLabeled
                    labelProps={{
                        labelText: 'Use Property Entrata Calendar for Tour Scheduling Availability?'
                    }}
                    toggle={true}
                    onChange={() =>
                        !isUser &&
                        props.update({
                            ...props.config!,
                            useForAvailability: !props.config!.useForAvailability
                        })
                    }
                    inputProps={{
                        id: `entrata-calendar`,
                        name: `entrata-calendar`,
                        checked: props.config.useForAvailability,
                        disabled: isUser  
                    }}
                />
                <CheckboxLabeled
                    labelProps={{ labelText: 'Suppress tour forwarding to Entrata Calendar?' }}
                    toggle={true}
                    inputProps={{
                        id: `entrata-suppress-forwarding`,
                        name: `entrata-suppress-forwarding`,
                        checked: props.config.suppressTourForwarding,
                        disabled: isUser  
                    }}
                    onChange={() =>
                        !isUser &&
                        props.update({
                            ...props.config!,
                            suppressTourForwarding: !props.config!.suppressTourForwarding
                        })
                    }
                />
                <CheckboxLabeled
                    labelProps={{ labelText: 'Enable self-guided indication' }}
                    toggle={true}
                    inputProps={{
                        id: `entrata-self-guided`,
                        name: `entrata-self-guided`,
                        checked: props.config.enableSelfGuided,
                        disabled: isUser  
                    }}
                    onChange={() =>
                        !isUser &&
                        props.update({
                            ...props.config!,
                            enableSelfGuided: !props.config!.enableSelfGuided
                        })
                    }
                />
            </div>
        )}
    </CollapsibleCard>
);
};
export default EntrataConfigurationSection;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/EntrataConfigurationSection.tsx